NtechApp.ViewBusinessAccAbout = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._mapStartCoords = null;
    this._locationMap = null;
    this._locationModalMap = null;
    this._workingHoursForm = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._findMapStartCoords();

        me._locationMap = new NtechApp.ViewBusinessAccAboutLocationMap(me._$view, me._mapStartCoords);
        me._locationModalMap = new NtechApp.ViewBusinessAccAboutModalLocationMap(me._$view, me._mapStartCoords);
        me._workingHoursForm = new NtechApp.ViewBusinessAccAboutModalWorkingHoursForm(me._$view);

        me._bindEvents();
    }

    this._bindEvents = function() {
    }

    this._unbindEvents = function() {
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ViewBusinessAccAbout, {
    _findMapStartCoords: function() {
        var me = this;

        var $locationMap = me._$view.find("[data-businessLocationMap]");
        var startCoords = {
            lat: parseFloat($locationMap.attr("data-locationLat")), 
            lng: parseFloat($locationMap.attr("data-locationLon"))
        };

        this._mapStartCoords = startCoords;
    }
});